import React from 'react'
import styled from 'styled-components'
import { FORMULARIO_INSTAGRAM, INSTAGRAM_CLUBE } from '../../data/links'
import { theme } from '../../styles'

const LinkTexto = styled.a`
  color: ${theme.cores.accent};
  font-weight: 700;
  text-decoration: underline;

  &:hover {
    color: #C56415;
  }
`

export default function InstagramCta() {
  return (
    <p>
      Aproveite e preencha o seu perfil do Instagram{ ' ' }
      <LinkTexto
        href={ FORMULARIO_INSTAGRAM }
        rel="noopener noreferrer"
        target="_blank"
      >neste formulário
      </LinkTexto>
      { ' ' }e siga o perfil { INSTAGRAM_CLUBE }
    </p>
  )
}
